/**
 * @generated SignedSource<<3ef214d218939c303f6f27912c2a1c9b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ResendTwoFactorCodePayload",
    "kind": "LinkedField",
    "name": "resendTwoFactorCode",
    "plural": false,
    "selections": [
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "success",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notice",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "needsAuthentication",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ValidationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "field",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "messages",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "type": "MutationResult",
        "abstractKey": "__isMutationResult"
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ResendTwoFactorCodeMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ResendTwoFactorCodeMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "4ad84e1ca47cec7d6227eef74c744b3d",
    "id": null,
    "metadata": {},
    "name": "ResendTwoFactorCodeMutation",
    "operationKind": "mutation",
    "text": "mutation ResendTwoFactorCodeMutation {\n  resendTwoFactorCode {\n    ... on MutationResult {\n      __isMutationResult: __typename\n      success\n      notice\n      needsAuthentication\n      errors {\n        field\n        messages\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "361268be00b155c6682074b60bebd384";

module.exports = node;
